import React,{Component} from 'react';

import moment from 'moment';

import Wrapper from '../Wrapper';

import './Videos.less';

class Videos extends Component{
  constructor(props){
    super(props);
    const {data} = props;
    const paylists = data.videos;
    this.playlistTitels = paylists.map(playlist => playlist.title);
    this.state = {
      activePlaylistTitle: this.playlistTitels[0],
      activeVideo: paylists[0].videos[0].id
    };
  }

  selectVideo = (video) => {
    this.setState({
      activeVideo: video
    })
  }

  selectPlaylist = (playlist) => {
    const {data} = this.props;
    const videos = data.videos.filter(el => el.title === playlist)[0].videos;
    this.setState({
      activePlaylistTitle: playlist,
      activeVideo: videos[0].id
    });
    document.querySelector('.thumbnails').scrollLeft = 0;
  }

  render(){
    const {activeVideo,activePlaylistTitle} = this.state;

    const {data} = this.props;
    const activePlaylist = data.videos.filter(playlist => playlist.title === activePlaylistTitle)[0];
    // console.log(activePlaylist.videos);
    const videos = activePlaylist.videos;
    return (
      <Wrapper title="Videos" fullwidth menuItems={this.playlistTitels} menuAction={this.selectPlaylist} {...this.props}>
      <div className={`middle video ${this.props.res}`}>
        <iframe width="560" height="349" src={`https://www.youtube-nocookie.com/embed/${activeVideo}?rel=0&hd=1`} frameBorder="0" allowFullScreen></iframe>
      </div>
      <div className={`thumbnails ${this.props.res}`}>
        {
          videos.map(video => <Thumbnail key={video.id} active={video.id == activeVideo} onClick={this.selectVideo} {...video}/>)
        }
      </div>
      </Wrapper>
    )
  }
}

export default Videos

const Thumbnail = ({id,title,onClick,active,published_at}) => {
  const pubDate = moment(published_at);
  return (
    <div className={active ? 'thumbnail thumbnail-active' : 'thumbnail'} onClick={() => onClick(id)}>
      <img className='thumbnail-image' src={`https://i.ytimg.com/vi/${id}/mqdefault.jpg`} alt='' />
      <p className='thumbnail-title'>{title}</p>
      <p className='thumbnail-info'>{pubDate.format('DD.MM.YYYY')}</p>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/sections/Videos.js